import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://eucaxsfnasxiljfofsol.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV1Y2F4c2ZuYXN4aWxqZm9mc29sIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcyOTY4ODIsImV4cCI6MjA5Mjg3Mjg4Mn0.WU5hQNfF-40LXq9oPjOBsWjYNgxMMaaf2f1Px1yC47o';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
